import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/AQIB-NAWAB'
      className='link footer__link' target="_blank"
    >
  Muhammad Aqib
    </a>
  </footer>
)

export default Footer
